module.exports = __webpack_public_path__ + "img/stolen-vehicle-recovery-process.deeae895.svg";